import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faUser,
  faInfoCircle,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import QocTracker from '@eams-dev/js-qoc-tracker';

import {
  URL_SECURE_USER_DASHBOARD,
  URL_SECURE_USER_PROFILE,
  URL_SECURE_USER_ABOUT_US,
  URL_PUBLIC_ABOUT_US
} from '_constants/urls';
import { URL_LOGIN } from '../../../constants/urls';

const componentBaseClass = 'links';

function NavLinks(props = {}) {
  const {
    onLogoutCheck,
    isLoginPathname,
    authenticated,
    onClickHamburger
  } = props;

  function trackNavBarClick(name) {
    console.log('nav bar clicked');
    onClickHamburger();
    QocTracker.trackEvent({
      eventName: name.concat(`-icon`),
      eventPayload: {
        clientData: {
          screen: 'user-dashboard'
        }
      }
    });
  }

  if (authenticated) {
    return (
      <div className="links">
        <Link
          className="navbar-link"
          to={URL_SECURE_USER_DASHBOARD}
          onClick={() => trackNavBarClick('dashboard')}
        >
          <FontAwesomeIcon icon={faHome} />
          <p className="dtext">Dashboard</p>
        </Link>
        <Link
          className="navbar-link"
          to={URL_SECURE_USER_PROFILE}
          onClick={() => trackNavBarClick('profile')}
        >
          <FontAwesomeIcon icon={faUser} />
          <p className="dtext">Profile</p>
        </Link>
        <Link
          className="navbar-link"
          to={URL_SECURE_USER_ABOUT_US}
          onClick={() => trackNavBarClick('about-us')}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
          <p className="dtext">About Us</p>
        </Link>
        <button
          onClick={onLogoutCheck}
          type="button"
          className="btn btn-link navbar-link"
        >
          <FontAwesomeIcon icon={faSignOutAlt} />
          <p className="dtext">Logout</p>
        </button>
      </div>
    );
  }

  if (isLoginPathname) {
    return (
      <div className={componentBaseClass}>
        <Link className="navbar-link" to={URL_PUBLIC_ABOUT_US}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <p className="dtext">About Us</p>
        </Link>
      </div>
    );
  }

  return (
    <div className={componentBaseClass}>
      <Link className="navbar-link" to={URL_PUBLIC_ABOUT_US}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <p className="dtext">About Us</p>
      </Link>
      <Link className="navbar-link" to={URL_LOGIN}>
        <FontAwesomeIcon icon={faSignOutAlt} />
        <p className="dtext">Return to Login</p>
      </Link>
    </div>
  );
}

NavLinks.propTypes = {
  onLogoutCheck: PropTypes.func.isRequired,
  isLoginPathname: PropTypes.bool,
  authenticated: PropTypes.bool.isRequired,
  onClickHamburger: PropTypes.func.isRequired
};
NavLinks.defaultProps = {
  isLoginPathname: false
};

export default NavLinks;
